// extracted by mini-css-extract-plugin
module.exports = {"btns":"btns-ebfca1913157a4d91b82e31367d02169"};